"use client"

import Script from "next/script"

// Google renders the button into this div once publisher.js loads. The
// attribute is Google's contract, not a React prop, so it goes through a
// spread. Eligibility is domain-level (whatgrassisthis.com qualifies).
// Docs: https://developers.google.com/search/docs/appearance/preferred-sources
const BUTTON_HOST_ATTRS = { "google-add-preferred-source-btn": "", "data-theme": "light" } as const

export function GooglePreferredSourceButton() {
  return (
    <>
      <Script src="https://news.google.com/swg/js/v1/publisher.js" strategy="lazyOnload" />
      {/* min-height reserves the rendered button's space to avoid footer layout shift */}
      <div className="min-h-[40px]" {...(BUTTON_HOST_ATTRS as Record<string, string>)} />
    </>
  )
}
